import React from 'react';
import {
  diabetes_management,
  bp_management,
  pregnancyIMG,
  weightmanagement,
  healthcoach,
} from '../../../../assets/images';
import { MetricCard } from '../../atoms';
import { commaingNumber } from '../../../../utils';

const HealthCoachPrograms = ({ metricObj, medicalObj, loading }) => {
  const { total_enrollment, ongoing_enrollment } = metricObj;
  const { bp, care_management, diabetes, non_sponsored_pregnancy, weight, sponsored_pregnancy } = medicalObj;

  return (
    <div>
      <p className='mt-8 mb-3 font-semibold text-gray-700 text-base leading-none'>Enrollment</p>
      <div className='flex flex-row justify-between'>
        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={healthcoach}
          title='Total Enrollments'
          metricValue={<span className='font-semibold text-3xl text-gray-700'>{commaingNumber(total_enrollment)}</span>}
          metricValueSuffix='(Employees + Dependents)'
          classes='w-1/2 mr-4'
        />

        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={healthcoach}
          title='Ongoing Enrollments'
          metricValue={
            <span className='font-semibold text-3xl text-gray-700'>{commaingNumber(ongoing_enrollment)}</span>
          }
          metricValueSuffix='(Employees + Dependents)'
          classes='w-1/2'
        />
      </div>
      <p className='text-sm text-gray-500 mt-2 mb-0 italic leading-none'>
        Total & ongoing enrollments include sponsored and self paid programs
      </p>

      {(!!care_management || !!sponsored_pregnancy || loading) && (
        <p className='mt-12 mb-3 font-semibold text-gray-700 text-base leading-none'>Sponsored Programs</p>
      )}
      <div className='flex flex-row justify-between'>
        {(!!care_management || loading) && (
          <MetricCard
            loading={loading}
            loaderHeight={120}
            svgsrc={weightmanagement}
            title='Care Management Program'
            metricValue={
              <span className='font-semibold text-3xl text-gray-700'>{commaingNumber(care_management)}</span>
            }
            metricValueSuffix='(Employees + Dependents)'
            classes='w-1/2 mr-4'
          />
        )}

        {(!!sponsored_pregnancy || loading) && (
          <MetricCard
            loading={loading}
            loaderHeight={120}
            svgsrc={pregnancyIMG}
            title='Pregnancy Care Program'
            metricValue={
              <span className='font-semibold text-3xl text-gray-700'>{commaingNumber(sponsored_pregnancy)}</span>
            }
            metricValueSuffix='(Employees / Dependents)'
            classes='w-1/2'
          />
        )}
      </div>

      <p className='mt-12 mb-3 font-semibold text-gray-700 text-base leading-none'>
        Self paid Health Coach Programs
      </p>
      <div className='flex flex-row justify-between'>
        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={weightmanagement}
          title='Weight Management Program '
          metricValue={<span className='font-semibold text-3xl text-gray-700'>{commaingNumber(weight)}</span>}
          metricValueSuffix='(Employees + Dependents)'
          classes='w-1/4 mr-2'
        />

        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={bp_management}
          title='Blood Pressure Management'
          metricValue={<span className='font-semibold text-3xl text-gray-700'>{commaingNumber(bp)}</span>}
          metricValueSuffix='(Employees + Dependents)'
          classes='w-1/4 mr-2'
        />

        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={diabetes_management}
          title='Diabetes Management Program'
          metricValue={<span className='font-semibold text-3xl text-gray-700'>{commaingNumber(diabetes)}</span>}
          metricValueSuffix='(Employees + Dependents)'
          classes='w-1/4 mr-2'
        />

        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={pregnancyIMG}
          title='Pregnancy Care Program'
          metricValue={
            <span className='font-semibold text-3xl text-gray-700'>{commaingNumber(non_sponsored_pregnancy)}</span>
          }
          metricValueSuffix='(Employees + Dependents)'
          classes='w-1/4'
        />
      </div>
    </div>
  );
};

export default HealthCoachPrograms;
